module.exports = __webpack_public_path__ + "static/my-0d73b1d3c9f6309542a1fb9cddeb4d81.png";